import { render, staticRenderFns } from "./FoodCounter.vue?vue&type=template&id=65c9c8c0&scoped=true&"
import script from "./FoodCounter.vue?vue&type=script&lang=js&"
export * from "./FoodCounter.vue?vue&type=script&lang=js&"
import style0 from "./FoodCounter.vue?vue&type=style&index=0&id=65c9c8c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9c8c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
